<template>
  <button><Icon name="bx:menu-alt-left" size="26px" /></button>
</template>
<script setup lang="ts"></script>
<style lang="scss" scoped></style>
